import { api } from "./apiClient";

const authAPI = {
  me() {
    return api.get("/auth/me").then((response) => response.data);
  },
  resolveClinic(subdomain) {
    return api
      .get(`/auth/clinic/${subdomain}`)
      .then((response) => response.data);
  },
  logIn(subdomain, login, password, role) {
    return api
      .post(
        "/auth/login",
        { subdomain, email: login, login, password, role },
        { skipAuthRefresh: true },
      )
      .then((response) => response.data);
  },
  logInPlatformAdmin(email, password) {
    return api
      .post(
        "/auth/platform-login",
        { email, password },
        { skipAuthRefresh: true, skipTenant: true },
      )
      .then((response) => response.data);
  },
  logInOwner(email, password) {
    return api
      .post(
        "/auth/owner-login",
        { email, login: email, password },
        { skipAuthRefresh: true, skipTenant: true },
      )
      .then((response) => response.data);
  },
  platformMe() {
    return api
      .get("/auth/platform-me", { skipTenant: true })
      .then((response) => response.data);
  },
  platformLogOut() {
    return api
      .post("/auth/platform-logout", null, { skipAuthRefresh: true, skipTenant: true })
      .then((response) => response.data);
  },
  register(payload) {
    return api
      .post("/auth/register", payload, { skipAuthRefresh: true, skipTenant: true })
      .then((r) => r.data);
  },
  checkRegisterOwnerEmail(email) {
    return api
      .get("/auth/register/check-owner-email", {
        params: { email },
        skipAuthRefresh: true,
        skipTenant: true,
      })
      .then((r) => r.data);
  },
  sendRegisterPhoneCode(phone) {
    return api
      .post(
        "/auth/register/send-phone-code",
        { phone },
        { skipAuthRefresh: true, skipTenant: true },
      )
      .then((r) => r.data);
  },
  verifyRegisterPhoneCode(phone, code) {
    return api
      .post(
        "/auth/register/verify-phone-code",
        { phone, code },
        { skipAuthRefresh: true, skipTenant: true },
      )
      .then((r) => r.data);
  },
  registerClient(payload) {
    return api
      .post("/auth/register-client", payload, { skipAuthRefresh: true })
      .then((r) => r.data);
  },
  getRegistrationLinkInfo(token) {
    return api
      .get(`/auth/registration-link/${encodeURIComponent(token)}`, {
        skipAuthRefresh: true,
      })
      .then((r) => r.data);
  },
  registerByLink(payload) {
    return api
      .post("/auth/register-by-link", payload, { skipAuthRefresh: true })
      .then((r) => r.data);
  },
  inviteTrainer(payload) {
    return api.post("/auth/invite-trainer", payload).then((r) => r.data);
  },
  inviteStaff(payload) {
    return api.post("/team/invite", payload).then((r) => r.data);
  },
  logOut() {
    return api
      .post("/auth/logout", null, { skipAuthRefresh: true })
      .then((response) => response.data);
  },
  refreshToken() {
    return api
      .post("/auth/refresh-token", null, { skipAuthRefresh: true })
      .then((res) => res.data);
  },
  forgotPassword(email, subdomain) {
    return api
      .post(
        "/auth/forgot-password",
        { email, subdomain },
        { skipAuthRefresh: true },
      )
      .then((r) => r.data);
  },
  resetPassword(token, email, password, subdomain) {
    return api
      .post(
        "/auth/reset-password",
        { token, email, password, subdomain },
        { skipAuthRefresh: true },
      )
      .then((r) => r.data);
  },
  adminSetUserPassword(userId, password) {
    return api
      .post("/auth/admin-set-password", { userId, password })
      .then((r) => r.data);
  },
  changePassword(current_password, password) {
    return api
      .post("/auth/change-password", { current_password, password })
      .then((r) => r.data);
  },
  updateMyAccount(data) {
    return api.patch("/auth/me", data).then((r) => r.data);
  },
};

export default authAPI;
